import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./GroupCRUD";
import { groupSlice } from "./GroupSlice";

const { actions } = groupSlice;

export const callMemberCommissionUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .callGroupUI(queryParams)
    .then((response) => {
      if (response && response.data) {
        if (!response.data.isAbort) {
          dispatch(actions.memberCommissionUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberCommissionUIFetched");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
export const callMemberGroup = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .callGroupUI(queryParams)
    .then((response) => {
      if (response && response.data) {
        if (!response.data.isAbort) {
          dispatch(actions.memberGroupFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberGroupFetched");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
